import { TRANSLATIONS } from '../../../translations';

export const configFilterDuration = [
  {
    id: 1,
    title: '0 - 5 ' + TRANSLATIONS.HOURS,
    value: [0, 5 * 60],
  },
  {
    id: 2,
    title: '5 - 10 ' + TRANSLATIONS.HOURS,
    value: [5 * 60, 24 * 60],
  },
  {
    id: 3,
    title: TRANSLATIONS.MORE_DAYS,
    value: [24 * 60, Infinity],
  },
];

export const configFilterTimeSlots = [
  {
    id: 1,
    title: '8:00 - 12:00',
    value: [1, 0, 0],
  },
  {
    id: 2,
    title: '12:00 - 17:00',
    value: [0, 1, 0],
  },
  {
    id: 3,
    title: '17:00 - 00:00',
    value: [0, 0, 1],
  },
];

export const configFilterPrices = [
  {
    id: 1,
    title: '0 - 30 €',
    value: [0, 30],
  },
  {
    id: 2,
    title: '30 - 50 €',
    value: [30, 50],
  },
  {
    id: 3,
    title: '50 - 100 €',
    value: [50, 100],
  },
  {
    id: 4,
    title: '100 - 200 €',
    value: [100, 200],
  },
  {
    id: 5,
    title: '200+ €',
    value: [200, Infinity],
  },
];

export const configFilterAccessibilities = [
  {
    id: 3,
    title: 'Accessibile in carrozzina',
    value: 1,
  },
];

export const configDistanceLimit = 150;

export const configFilterParticipantsAge = [
  { value: 0, label: '0' + ' ' + TRANSLATIONS.YEARS },
  { value: 1, label: '1' + ' ' + TRANSLATIONS.YEAR },
  { value: 2, label: '2' + ' ' + TRANSLATIONS.YEARS },
  { value: 3, label: '3' + ' ' + TRANSLATIONS.YEARS },
  { value: 4, label: '4' + ' ' + TRANSLATIONS.YEARS },
  { value: 5, label: '5' + ' ' + TRANSLATIONS.YEARS },
  { value: 6, label: '6' + ' ' + TRANSLATIONS.YEARS },
  { value: 7, label: '7' + ' ' + TRANSLATIONS.YEARS },
  { value: 8, label: '8' + ' ' + TRANSLATIONS.YEARS },
  { value: 9, label: '9' + ' ' + TRANSLATIONS.YEARS },
  { value: 10, label: '10' + ' ' + TRANSLATIONS.YEARS },
  { value: 11, label: '11' + ' ' + TRANSLATIONS.YEARS },
  { value: 12, label: '12' + ' ' + TRANSLATIONS.YEARS },
  { value: 13, label: '13' + ' ' + TRANSLATIONS.YEARS },
  { value: 14, label: '14' + ' ' + TRANSLATIONS.YEARS },
  { value: 15, label: '15' + ' ' + TRANSLATIONS.YEARS },
  { value: 16, label: '16' + ' ' + TRANSLATIONS.YEARS },
  { value: 17, label: '17' + ' ' + TRANSLATIONS.YEARS },
  { value: 18, label: '18' + ' ' + TRANSLATIONS.YEARS },
];
